import { useVariant } from '@unleash/proxy-client-react';

import { FeatureFlag } from '../flags';
import { useUnleashFlag } from './use-unleash-flag';

const DEFAULT_MAINTENANCE_MESSAGE =
  'Revelio Terminal is currently undergoing maintenance. Please check back soon as systems should be operational shortly.';

export const useMaintenanceFlag = () => {
  const maintenanceOn = useUnleashFlag(FeatureFlag.Maintenance);
  const maintenanceVariant = useVariant(FeatureFlag.Maintenance);
  const maintenanceMessage = (() => {
    const message = maintenanceVariant?.enabled
      ? maintenanceVariant.payload?.value?.trim()
      : undefined;

    return message || DEFAULT_MAINTENANCE_MESSAGE;
  })();

  return { isOn: maintenanceOn, message: maintenanceMessage };
};
